module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABSUlEQVR4Ac3Rs6JeQRAH8P/sYWzbtlXGfoi8QNoY1deEfYw2tm3zMtc2DnZ2Yp900a/d8eKPIwCVh0cggZBoIQsgsiGagtPcZftzhWQiQoHdQ2BDsa7yG/bH0S0DwE6MhkjUbh76LGPUoPROsPOSSbtNTZ1fJAiLblQdZxhqGr/MiMvb4k0ReYQP1E/RWpx2ps04VDxWQnFultu3t923n8QxgJ87GCE37r8K/mBwJUUh5b7R546jpIhcLyGBdJ1pN4m5E29eTe16mIlT8fyRKc6nhnrYzg8jicDodmOD1ou43nijp/HRg7xze7OVKW/WIokiAN93sLQ0HxMES3n3ZfQrDp89IMPWq6eN65aDNXn+dwnkQefZjdfL5OU61JY1HbMxchwtoCZNzZsMkPowj3z96dLUsMYTLPWaXAVSUBYMI0nPKy/x/3kLQ36d+tEJVCMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BT.png
// module id = 1099
// module chunks = 0